import React from 'react'
import { Icon, Divider } from '@chakra-ui/react'
import { FaListCheck } from 'react-icons/fa6'
import ActionItemBlock from './action-item-block'
import DashboardSectionCard from '../section-card'
import EmptyActionItems from './empty-action-items'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { useActionItems } from '../../../contexts/action-item-provider'
import PendingActionHistoryButton from './pending-action-history-button'
import PetSelfieSummaryBlock from './pet-selfie-summary-block'
import { ActionItemType } from '~graphql/generated/graphql'

export const scrollbarCSS = {
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-track': {
        width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c2c2c2',
        borderRadius: '24px',
    },
}

export default function ActionItemList() {
    return (
        <DashboardSectionCard
            icon={<Icon as={FaListCheck} color="brand.600" fontSize="xl" />}
            title="Action Required"
            headerAction={<PendingActionHistoryButton />}
            bodyProps={{ p: 4, pt: 4 }}
        >
            <ActionItems />
        </DashboardSectionCard>
    )
}

const ActionItems: React.FC = () => {
    const { actionItems, isLoading } = useActionItems()

    const petSelfieActionItems = actionItems.filter(
        item => item.type === ActionItemType.PetSelfieSubmitted,
    )
    const individualActionItems = actionItems.filter(
        item => item.type !== ActionItemType.PetSelfieSubmitted,
    )

    return (
        <SharedStack divider={<Divider />}>
            {actionItems.length ? (
                individualActionItems.map(item => (
                    <ActionItemBlock key={item.id} actionItem={item} />
                ))
            ) : (
                <EmptyActionItems />
            )}
            {petSelfieActionItems.length > 0 && (
                <PetSelfieSummaryBlock
                    petSelfieActionItems={petSelfieActionItems}
                />
            )}
        </SharedStack>
    )
}
